import { createContext, useContext, type ReactNode } from 'react';
import type { DataConfig } from '../../model/types';
import type { DataFetchers } from '../../model/useDataFetchers';
import { useDataFetchers } from '../../model/useDataFetchers';

const DataFetchersContext = createContext<DataFetchers | null>(null);

interface Props {
  preset: unknown;
  children: ReactNode;
}

export function DataFetchersProvider({ preset, children }: Props) {
  const fetchers = useDataFetchers(preset as DataConfig);

  return (
    <DataFetchersContext.Provider value={fetchers}>
      {children}
    </DataFetchersContext.Provider>
  );
}

export function useDataFetchersContext(): DataFetchers {
  const ctx = useContext(DataFetchersContext);

  if (!ctx) {
    throw new Error(
      'useDataFetchersContext must be used within DataFetchersProvider',
    );
  }

  return ctx;
}
